import {Linking, Platform} from 'react-native';
import {LogLevel, OneSignal} from 'react-native-onesignal';

import {Config} from '../config';

import {logger} from './logger';

let lastNotificationUrl: string | null = null;

const setLastNotificationUrl = (url: string | null) => {
  lastNotificationUrl = url;
};

export const getLastNotificationUrl = () => {
  return lastNotificationUrl;
};

export const clearLastNotificationUrl = () => {
  setLastNotificationUrl(null);
};

interface OneSignalService {
  initialiseOneSignal: (config: Config) => Promise<void>;
  login: () => Promise<void>;
  logout: () => Promise<void>;
}

const mobileImplementation: OneSignalService = {
  initialiseOneSignal: async (config: Config) => {
    if (config.ENV === 'DEV' || config.ENV === 'BETA') {
      OneSignal.Debug.setLogLevel(LogLevel.Verbose);
    }

    if (!config.ONESIGNAL_APP_ID) {
      logger.error('OneSignal', 'Failed to initialise: ONESIGNAL_APP_ID is not set');
      return;
    }

    OneSignal.initialize(config.ONESIGNAL_APP_ID);
    OneSignal.Notifications.requestPermission(true);

    OneSignal.Notifications.addEventListener('click', async event => {
      logger.debug('OneSignal', 'Handling notification click', {
        notificationId: event.notification.notificationId,
      });

      const {launchURL = ''} = event.notification;
      const canOpen = await Linking.canOpenURL(launchURL);

      logger.debug('OneSignal', 'Can open URL check', {canOpen, url: launchURL});

      if (launchURL && canOpen) {
        logger.debug('OneSignal', 'Got URL, manually emitting event', {launchURL});
        setLastNotificationUrl(launchURL);
        // This is our workaround - manually trigger the URL event that iOS isn't sending
        callback?.();
      }
    });
  },
  login: async () => {
    // TODO: Implement mobile login
  },
  logout: async () => {
    // TODO: Implement mobile logout
  },
};

const webImplementation: OneSignalService = {
  initialiseOneSignal: async (_config: Config) => {
    // TODO: Implement web initialisationgi
  },
  login: async () => {
    // TODO: Implement web login
  },
  logout: async () => {
    // TODO: Implement web logout
  },
};

// Export the platform-specific implementation
export const {initialiseOneSignal, login, logout} = Platform.select({
  web: webImplementation,
  default: mobileImplementation,
});

export const testDeepLink = (url: string) => {
  logger.debug('OneSignal', 'Manually testing deep link', {url});
  // Don't use Linking.openURL for Universal Links testing
  // Instead, simulate an incoming URL event
  Linking.emit('url', {url});
};
